import { useState } from "react"
import { useTranslation } from "react-i18next";
import { FormField, SpinnerCircular, Icon } from '@weirgroup/weir-dls'
import { getPartLookup } from "../../api/part-lookup.api"
import { PointsTable } from "./components/points-table";
import { PartLookupComponentType, PartLookupType } from "../../types/part-lookup.type";
import { AttachmentInfoTable } from "./components/attachment-info-table";
import "./styles.scss";
import { useDarkMode } from "../../hooks/use-darkmode";

export const PartLookUp = () => {
    const [serialNumber, setSerialNumber] = useState<string>("")
    const [attachmentInfo, setAttachmentInfo] = useState<PartLookupType | null>(null)
    const [points, setPoints] = useState<PartLookupComponentType[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [noResults, setNoResults] = useState<boolean>(false)
    const { t } = useTranslation();
    const {darkMode} = useDarkMode();
    const handleSearchSerialNumber = () =>{
        if (serialNumber) {
            setIsLoading(true)
            getPartLookup(serialNumber).then((result: any) => {
                setIsLoading(false)
                setAttachmentInfo(result.data.data);
                setPoints(result.data.data.components)
                if (!result.data.data.serial_number) {
                    setNoResults(true);
                }
            }).catch((err) => {
                setIsLoading(false)
                console.error(err);
            })
        }
    }
    
    return (
        <div className="part-lookup-container" style={{backgroundColor:darkMode ? '#3B434C' : '#F6F7F8'}}>
            <div className="header">
                <p className="title" style={{color:darkMode ? 'white' : 'black'}}>{t("partLookupTitle").toString()}</p>
                <div className="search">
                    <FormField
                        darkMode={darkMode}
                        id="serialNum"
                        name="InputBox"
                        size={'md'}
                        placeholder={t("partLookupPlaceholder")}
                        disabled={isLoading}
                        required={true}
                        full
                        value={serialNumber}
                        onChange={(e: any) => {
                            setSerialNumber(e.target.value);
                        }}
                        onKeyPress={(e: any) => {
                            
                            
                            if (e.code == "Enter" || e.code == "NumpadEnter") {
                                setNoResults(false);
                                handleSearchSerialNumber()
                            }
                        }}
                        autoComplete="off"
                        icon={isLoading ? "Horizontal" : "Search"}
                        onIconClick={() => handleSearchSerialNumber()}
                    />
                </div>
            </div>
            {attachmentInfo?.serial_number ?
                <div id="attachment-data">
                    <AttachmentInfoTable attachmentInfo={attachmentInfo} darkMode={darkMode} />
                    <PointsTable points={points} darkMode={darkMode} />
                </div>
                : noResults ?
                    <div className="no-results">
                        <p><Icon name="Info" darkMode={darkMode}/>{t('noResultPartLookup').toString()} "<span>{serialNumber}</span>". {t('noResultSecondPartLookup').toString()}. </p>
                    </div>
                    : <></>
            }
            {isLoading ?
                <div className="spinner">
                    <SpinnerCircular darkMode={darkMode}/>
                    <p className="spinner-label" style={{color:darkMode ? "white" : "black"}}>{t('loading').toString()}</p>
                </div> : <></>
            }
        </div>
    )
}